import React from 'react'

function Hero() {
  return (
    <div className='hero-container'>
        <h2>MLS Multiple Listing Service Listings</h2>
        <p>Your Trusted Real Estate Sources</p>
        <button>SEARCH LISTINGS</button>
    </div>
  )
}

export default Hero